module.exports = __webpack_public_path__ + "static/media/privacy.9accf167.md";


//////////////////
// WEBPACK FOOTER
// ./src/markdown/privacy.md
// module id = 1375
// module chunks = 0